var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
const SvgPackage = _a => {
  var {
      size
    } = _a,
    props = __rest(_a, ["size"]);
  return React.createElement("svg", Object.assign({
    width: size || 24,
    height: size || 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: props.role,
    "aria-hidden": props['aria-hidden'] || true
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3733 9.2877C17.3686 9.29007 17.364 9.29239 17.3593 9.29466L12.9855 11.4816V21.3475L20.4425 17.6189C20.8483 17.4173 21.105 17.0034 21.1053 16.5506V7.44737C21.1053 7.43885 21.1052 7.43034 21.105 7.42184L17.3733 9.28769L17.3733 9.2877ZM9.0996 3.87671L17.0454 7.84961L20.2149 6.26486L12.7998 2.55729C12.4652 2.39131 12.0722 2.39142 11.7393 2.55684L9.0996 3.87671ZM7.49758 4.67772L4.3233 6.26485L12.2691 10.2378L15.4434 8.65062L7.49758 4.67772ZM7.10351 3.27274C7.14782 3.24412 7.19504 3.22056 7.24422 3.20238L11.1001 1.27444C11.8365 0.908521 12.7017 0.908521 13.4381 1.27444L21.0802 5.09548C21.9729 5.53908 22.5376 6.44975 22.5381 7.44699V16.551C22.5376 17.5479 21.9729 18.4585 21.0818 18.9013L13.4399 22.7223C12.6999 23.0926 11.8287 23.0926 11.089 22.7224L3.44491 18.9003C2.55305 18.451 1.99313 17.5347 2.00006 16.5411L2.00006 7.44661C2.00059 6.44975 2.56531 5.53908 3.45644 5.09627L7.10351 3.27274L7.10351 3.27274ZM11.5526 21.3522V11.4815L3.43323 7.42184C3.43305 7.43021 3.43296 7.43859 3.43295 7.44699L3.43294 16.5461C3.42978 17 3.68428 17.4165 4.0877 17.6197L11.5526 21.3522Z",
    fill: props.color || 'currentColor'
  }));
};
export default SvgPackage;